import type { ReactNode } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface AdminPagerProps {
  page: number;
  totalPages: number;
  total: number;
  label: string;
  onPrev: () => void;
  onNext: () => void;
}

export function AdminPager({ page, totalPages, total, label, onPrev, onNext }: AdminPagerProps) {
  return (
    <div className="admin-pager">
      <p className="admin-pager__meta">
        <span className="admin-pager__count tabular">{total}</span> {label}
      </p>
      <div className="admin-pager__controls">
        <button
          type="button"
          className="app-list-pager__arrow"
          disabled={page <= 1}
          onClick={onPrev}
          aria-label="Previous page"
        >
          <ChevronLeft />
        </button>
        <span className="admin-pager__page tabular">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          className="app-list-pager__arrow"
          disabled={page >= totalPages}
          onClick={onNext}
          aria-label="Next page"
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
}

interface AdminPanelProps {
  children: ReactNode;
  className?: string;
  toolbar?: ReactNode;
}

export function AdminPanel({ children, className = "", toolbar }: AdminPanelProps) {
  return (
    <section className={`admin-panel ${className}`.trim()}>
      {toolbar ? <div className="admin-panel__toolbar">{toolbar}</div> : null}
      <div className="admin-panel__body">{children}</div>
    </section>
  );
}
